import styles from "./HeaderLayout.module.scss";
import logo from "../../../assets/logo.png";
import menu from "../../../assets/icons/menu.svg";
import openMenu from "../../../assets/icons/open-menu.svg";
import { useDispatch } from "react-redux";
import LanguagePicker from "../../LanguagePicker/LanguagePicker";
import { Outlet, Link, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import cx from "classnames";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import {
  logout,
  updateLicenseExpiredType,
  updateLicenseCanceledType,
  isUserPaddle,
} from "../../../store/reducers/auth-reducer";
import ExpiredHeaderLayout from "../ExpiredHeaderLayout/ExpiredHeaderLayout";
import { RoutePaths } from "../../../routes/RoutePaths";
import { resetApiState } from "../../../store/store";
import { useTranslation } from "react-i18next";
import { useGetSubscriptionsQuery } from "../../../store/services/details-api";

interface HeaderLayoutProps {
  hover?: boolean;
}

const HeaderLayout: React.FC<HeaderLayoutProps> = ({ hover = true }) => {
  const dispatch = useDispatch();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const dispatchApp = useAppDispatch();
  const menuRef = useRef<HTMLImageElement | null>(null);
  const expired = useAppSelector((state) => state.auth.expired);
  const canceled = useAppSelector((state) => state.auth.canceled);
  const { data } = useGetSubscriptionsQuery(null);
  const { t } = useTranslation();
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    dispatchApp(
      updateLicenseExpiredType(
        data?.every(
          (item) => item.license.features.length > 0 && item.license.features.every((feature) => feature.isExpired)
        ) || false
      )
    );
    dispatchApp(isUserPaddle(data?.some((item) => item.source === "Paddle") || false));
    dispatchApp(updateLicenseCanceledType(data?.every((item) => item.isCanceled) || false));
  }, [dispatchApp, data]);

  return (
    <>
      {(expired || canceled) && <ExpiredHeaderLayout />}
      <div className={styles.root}>
        <Link to={RoutePaths.HOME}>
          <img src={logo} alt="Fortect" className={styles.root_logo} />
        </Link>
        {hover && (
          <div className={cx(styles.root_actions, isMenuOpen ? styles.root_actions_open : "")}>
            <LanguagePicker border={true} />

            <img
              src={isMenuOpen ? openMenu : menu}
              ref={menuRef}
              alt="menu"
              onClick={toggleMenu}
              className={styles.root_menu_img}
            />
            {isMenuOpen && (
              <div className={styles.root_menu}>
                <p
                  className={styles.root_menu_item}
                  onClick={() => {
                    navigate("/account");
                  }}
                >
                  {t("My Account")}
                </p>
                <p
                  className={styles.root_menu_item}
                  onClick={() => {
                    navigate("/devices");
                  }}
                >
                  {t("Devices")}
                </p>
                <p
                  className={styles.root_menu_item}
                  onClick={() => {
                    navigate("/invoices");
                  }}
                >
                  {t("Invoices")}
                </p>
                <p
                  className={styles.root_menu_item}
                  onClick={() => window.open("https://www.fortect.com/support/", "_blank")}
                >
                  {t("Support")}
                </p>
                <p
                  className={styles.root_menu_item}
                  onClick={() => window.open("https://www.fortect.com/support/knowledge/", "_blank")}
                >
                  {t("Knowledge Base")}
                </p>
                <hr className={styles.root_menu_hr} />
                <p
                  onClick={() => {
                    dispatchApp(logout());
                    dispatch(resetApiState());
                    navigate("/");
                  }}
                  className={styles.root_menu_itemLogout}
                >
                  {t("Log Out")}
                </p>
              </div>
            )}
          </div>
        )}
      </div>

      <Outlet key={location.pathname} />
    </>
  );
};

export default HeaderLayout;
